import { Card } from '@/lib';
import { TranslationKeys } from '@/localization';
import { ComponentProps, FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type HomeDataSectionChartProps = {
  title: TranslationKeys;
  subtitle?: TranslationKeys;
  customHeader?: ReactNode;
} & Pick<ComponentProps<typeof Card>, 'className' | 'children'>;

export const HomeDataSectionChart: FC<HomeDataSectionChartProps> = ({ title, subtitle, customHeader, className, children, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Card className={twMerge('p-6 flex gap-6 flex-col col-span-2 @5xl/page:col-span-1 w-full', className)} {...rest}>
      <header className='flex justify-between'>
        <div className='grid gap-y-0.5'>
          <p className='font-semibold text-primary-900 first-letter:capitalize'>{t(title as any)}</p>
          {subtitle && <p className='text-sm text-tertiary-600 first-letter:capitalize'>{t(subtitle as any)}</p>}
        </div>
        {customHeader}
      </header>
      {children}
    </Card>
  );
};
